import { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';

import { page } from '@v2/services/analytics.service';
import { BuilderComponent, builder } from '@components/builderio/register-components';
import PageLoader from '@components/common/presentational/loader/page-loader';

import v2WrapperStyles from '@styles/wrapper';
import { useBuilderIO } from '@v2/hooks/builderio';

export default function BuilderIOReviews(props: RouteComponentProps) {
    const [pageData, setPageData] = useState(null);
    const [loading, setLoading] = useState(true);
    const isBuilderLoaded = useBuilderIO();

    useEffect(() => {
        page('Reviews');

        let script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://cdn1.stamped.io/files/widget.min.js';

        document.head.appendChild(script);

        (async function () {
            await builder.get('page', { url: '/reviews' }).promise().then(setPageData);
        })();
    }, []);

    useEffect(() => {
        if (!loading) {
            return;
        }

        const timer = setInterval(() => {
            if (window.StampedFn !== undefined && window.StampedFn.init && document.querySelector('#stamped-main-widget')) {
                window.StampedFn.init({
                    apiKey:'pubkey-rAbqd3Mw684rZI0BzOk7Yf5iV3Kc6J',
                    storeUrl:'www.cerebelly.com'
                });
                setLoading(false);
            }
        }, 1000);

        return () => clearInterval(timer);
    }, [loading]);

    return (
        <>
            {
                isBuilderLoaded ?

                <div className={`${v2WrapperStyles.v2Global} ${v2WrapperStyles.v2FullScreenPageWrapper}`}>
                    <BuilderComponent
                        model="page"
                        content={pageData} />
                </div> : null
            }
            {loading || !isBuilderLoaded ? <PageLoader overlay={true} /> : null}
        </>
    )
}
